import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { withTranslation } from "react-i18next";

const Slider = (props) => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile(); // Initial check
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const desktopImages = ["img/1.jpg", "img/2.jpg", "img/3.jpg"];
  const mobileImages = ["img/mobile1.jpg", "img/mobile2.jpg", "img/mobile3.jpg"];

  const imagesToRender = isMobile ? mobileImages : desktopImages;
  return (
    <div className='slider slider_home mb-3'>
      <div className='slider__container'>
        <OwlCarousel style={{ direction: "ltr" }} className="owl-theme" loop items={1}>
          {imagesToRender.map((src, index) => (
            <div key={index} className="slider__item justify-content-center align-items-center p-relative">
              <div className="slider__preview">
                <img src={src} alt={`slide-${index}`} style={{
                  width: "95%",
                  margin: "0 auto"
                }} />
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
};
export default withTranslation()(Slider); 